import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArrowDiagonalDownRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDiagonalDownRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a798b65996fdeea70cb51ec44c77aac31f776530', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7b6e99f362b09f9cbea2f5c853d4ac709692b28f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '644b6bc3025a3b25f913e52dc7b5f4769ac61f84', d: "M13.59 14.65H9.14a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .356-.148.5.5 0 0 0 .149-.356v-6.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v4.44l-7.579-7.58a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-arrow-diagonal-down-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-diagonal-down-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-diagonal-down-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDiagonalDownRight$1);
            }
            break;
    } });
}

const CosmosIconArrowDiagonalDownRight = CosmosIconArrowDiagonalDownRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDiagonalDownRight, defineCustomElement };
